// extracted by mini-css-extract-plugin
export var formContainer = "_jo-0";
export var message = "_jo-1";